import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  type APIResponse,
  type DashboardPinnedMatter,
  type PinnedMatter,
} from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

export interface CreateMatterPinnedRequest {
  matterId: string;
}

export const createMatterPinnedV1 = (data: CreateMatterPinnedRequest) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<PinnedMatter>>(`${baseFastApiMatterRoute}/pinned`, data)
    .then((res) => res.data);
};

export const deleteMatterPinnedV1 = (data: { pinnedMatterId: string }) => {
  const { pinnedMatterId } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<PinnedMatter>
    >(`${baseFastApiMatterRoute}/pinned/${pinnedMatterId}`)
    .then((res) => res.data);
};

export const retrievePinnedMattersV2 = () => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<DashboardPinnedMatter[]>
    >(`${baseFastApiMatterRoute}/pinned`)
    .then((res) => res.data);
};
